import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { VariableClinica } from '../../../../../core/models';
import { DispositivoGenerico } from '../dispositivo-generico.model';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';

/**
 *  Componente que representa al dispositivo Termómetro.
 *
 * @author lreverendo
 *
 * @version 01.02.0070
 * @since 01.02.0000
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tbody [termometro]',
  templateUrl: 'termometro.component.html',
  styleUrls: [
    '../../../biomedidas.component.css',
    '../../../views/registro-biomedida/registro-biomedida.component.css',
    './termometro.component.css'
  ]
})
export class TermometroComponent extends DispositivoGenerico implements OnInit {
  public temp: VariableClinica;

  constructor() {
    super();
  }

  public ngOnInit(): void {
    // Se busca la variable de temperatura.
    this.temp = this.variablesClinicas.find((v) => v.alias === 'T');

    if (this.temp) {
      this.forma.addControl(
        'temp',
        new FormControl('', [
          Validators.required,
          Validators.pattern(this.getPatronFormato(this.temp.formato)),
          CustomValidators.porRango(this.temp.min, this.temp.max)
        ])
      );
    }
  }

  public getData(): VariableClinica[] {
    const result: VariableClinica[] = [];

    if (this.temp) {
      const temp = this.forma.value.temp.replace(',', '.');

      if (Number(temp) === NaN) {
        return [];
      }

      this.temp.valor = temp;
      result.push(this.temp);
    }

    return result;
  }
}
